export const IOT_PRODUCTS_LIST = [
    {
        key: "b-iot-authentication-product", displayName: "Account Authorization APIs", value: "b-iot-authentication-product"
    },
    {
        key: "d-iot-product", displayName: "M2M APIs", value: "d-iot-product"
    },
    {
        key: "a-iot-rapid-product", displayName: "Rapid APIs", value: "a-iot-rapid-product"
    },
    
    {
        key: "d-esim-product", displayName: "eSIM APIs", value: "d-esim-product"
    },
    {
        key: "a-last-session-product", displayName: "Network Assurance APIs", value: "a-last-session-product"
    }

]


